module.exports = __webpack_public_path__ + "img/avatar4.12bb6892.jpg";